module.exports = __webpack_public_path__ + "static/media/person-icon.57ff924c.svg";